import { IntegrationCarlsJrModel } from '@/components/integrations/custom/carlsjr/Model';
import { IntegrationCookieModel } from '@/components/integrations/cookie/Model';
import { IntegrationCodanModel } from '@/components/integrations/custom/codan/Model';
import { IntegrationEspBrazeModel } from '@/components/integrations/esp/braze/Model';
import { IntegrationGrundfosModel } from '@/components/integrations/custom/grundfos/Model';
import { IntegrationClerkModel } from '@/components/integrations/clerk/Model';
import { IntegrationBulkPrizeVouchersModel } from '@/components/integrations/bulk-prize-vouchers/Model';
import { IntegrationDanskeSpilModel } from '@/components/integrations/custom/danskespil/Model';
import { IntegrationScandlinesModel } from '@/components/integrations/custom/scandlines/Model';
import { IntegrationSportsAllianceModel } from '@/components/integrations/custom/sports-alliance/Model';
import { IntegrationNfcModel } from '@/components/integrations/custom/nfc/Model';
import { IntegrationKristeligDagbladModel } from '@/components/integrations/custom/kristelig-dagblad/Model';
import { IntegrationEspClickdimensionModel } from '@/components/integrations/esp/clickdimension/Model';
import { IntegrationStockHandlingModel } from '@/components/integrations/stockhandling/Model';
import { IntegrationKlasselotterietModel } from '@/components/integrations/esp/custom/klasselotteriet/Model';
import { IntegrationBezzerwisserModel } from '@/components/integrations/custom/bezzerwisser/Model';
import { IntegrationEspFacebookConversionModel } from '@/components/integrations/esp/facebook-conversion/Model';
import { IntegrationGfAdvancedMapModel } from '@/components/integrations/custom/gf-advanced-map/Model';
import { IntegrationCoopModel } from '@/components/integrations/custom/coop/Model';
import { IntegrationDagrofaModel } from '@/components/integrations/custom/dagrofa/Model';
import { IntegrationEspEloquaModel } from '@/components/integrations/esp/eloqua/Model';
import { IntegrationGaModel } from '@/components/integrations/ga/Model';
import { IntegrationQiagenModel } from '@/components/integrations/custom/qiagen/Model';
import { IntegrationLidlModel } from '@/components/integrations/custom/lidl/Model';
import { IntegrationRecaptchaModel } from '@/components/integrations/recaptcha/Model';
import { IntegrationSaxoModel } from '@/components/integrations/custom/saxo/Model';
import { IntegrationKlasselotterietSegmentsModel } from '@/components/integrations/custom/klasselotteriet-segments/Model';
import { IntegrationKraeftensBekaempelseModel } from '@/components/integrations/custom/kaeftens-bekaempelse/Model';
import { IntegrationLidlProductsModel } from '@/components/integrations/custom/lidl-products/Model';
import { IntegrationPhilipMorrisModel } from '@/components/integrations/custom/philip-morris/Model';
import { IntegrationJwtModel } from '@/components/integrations/jwt/Model';
import { IntegrationOpenIdConnectModel } from '@/components/integrations/open-id-connect/Model';
import { IntegrationLobycoModel } from '@/components/integrations/custom/lobyco/Model';
import { IntegrationRitualsModel } from '@/components/integrations/custom/rituals/Model';
import { IntegrationUserneedsModel } from '@/components/integrations/custom/userneeds/Model';
import { IntegrationPixelTrackingModel } from '@/components/integrations/pixel-tracking/Model';
import { IntegrationRaptorSmartAdvisorModel } from '@/components/integrations/raptor-smart-advisor/Model';
import { IntegrationParticleGeneratorModel } from '@/components/integrations/particle-generator/Model';
import { IntegrationSmsToScreenModel } from '@/components/integrations/sms-to-screen/Model';
import { IntegrationCookieConsentModel } from '@/components/integrations/cookie-consent/Model';

export type IntegrationModel =
  | IntegrationStockHandlingModel
  | IntegrationEspEloquaModel
  | IntegrationQiagenModel
  | IntegrationDagrofaModel
  | IntegrationCarlsJrModel
  | IntegrationLidlModel
  | IntegrationCookieModel
  | IntegrationRecaptchaModel
  | IntegrationCodanModel
  | IntegrationEspBrazeModel
  | IntegrationSaxoModel
  | IntegrationKlasselotterietSegmentsModel
  | IntegrationKraeftensBekaempelseModel
  | IntegrationLidlProductsModel
  | IntegrationPhilipMorrisModel
  | IntegrationDanskeSpilModel
  | IntegrationJwtModel
  | IntegrationOpenIdConnectModel
  | IntegrationScandlinesModel
  | IntegrationLobycoModel
  | IntegrationCoopModel
  | IntegrationGrundfosModel
  | IntegrationClerkModel
  | IntegrationBulkPrizeVouchersModel
  | IntegrationRitualsModel
  | IntegrationUserneedsModel
  | IntegrationPixelTrackingModel
  | IntegrationKristeligDagbladModel
  | IntegrationSportsAllianceModel
  | IntegrationNfcModel
  | IntegrationGfAdvancedMapModel
  | IntegrationRaptorSmartAdvisorModel
  | IntegrationGaModel
  | IntegrationEspClickdimensionModel
  | IntegrationParticleGeneratorModel
  | IntegrationEspFacebookConversionModel
  | IntegrationBezzerwisserModel
  | IntegrationKlasselotterietModel
  | IntegrationSmsToScreenModel
  | IntegrationCookieConsentModel;

export type IntegrationModelType =
  | typeof IntegrationStockHandlingModel
  | typeof IntegrationEspEloquaModel
  | typeof IntegrationQiagenModel
  | typeof IntegrationCookieModel
  | typeof IntegrationDagrofaModel
  | typeof IntegrationLidlModel
  | typeof IntegrationCarlsJrModel
  | typeof IntegrationRecaptchaModel
  | typeof IntegrationCodanModel
  | typeof IntegrationEspBrazeModel
  | typeof IntegrationSaxoModel
  | typeof IntegrationKlasselotterietSegmentsModel
  | typeof IntegrationKraeftensBekaempelseModel
  | typeof IntegrationLidlProductsModel
  | typeof IntegrationPhilipMorrisModel
  | typeof IntegrationDanskeSpilModel
  | typeof IntegrationJwtModel
  | typeof IntegrationOpenIdConnectModel
  | typeof IntegrationScandlinesModel
  | typeof IntegrationLobycoModel
  | typeof IntegrationCoopModel
  | typeof IntegrationGrundfosModel
  | typeof IntegrationClerkModel
  | typeof IntegrationBulkPrizeVouchersModel
  | typeof IntegrationRitualsModel
  | typeof IntegrationUserneedsModel
  | typeof IntegrationPixelTrackingModel
  | typeof IntegrationKristeligDagbladModel
  | typeof IntegrationSportsAllianceModel
  | typeof IntegrationNfcModel
  | typeof IntegrationGfAdvancedMapModel
  | typeof IntegrationRaptorSmartAdvisorModel
  | typeof IntegrationGaModel
  | typeof IntegrationEspClickdimensionModel
  | typeof IntegrationParticleGeneratorModel
  | typeof IntegrationEspFacebookConversionModel
  | typeof IntegrationBezzerwisserModel
  | typeof IntegrationKlasselotterietModel
  | typeof IntegrationSmsToScreenModel
  | typeof IntegrationCookieConsentModel;

export const IntegrationModelMapping: Record<string, IntegrationModelType> = {
  stock_handling: IntegrationStockHandlingModel,
  'esp/eloqua': IntegrationEspEloquaModel,
  qiagen: IntegrationQiagenModel,
  customer_leadfamly_dagrofa: IntegrationDagrofaModel,
  customer_leadfamly_carls_jr: IntegrationCarlsJrModel,
  cookie: IntegrationCookieModel,
  customer_leadfamly_lidl: IntegrationLidlModel,
  recaptcha: IntegrationRecaptchaModel,
  customer_leadfamly_codan: IntegrationCodanModel,
  'esp/braze': IntegrationEspBrazeModel,
  customer_leadfamly_saxo: IntegrationSaxoModel,
  customer_leadfamly_klasselotteriet_segments: IntegrationKlasselotterietSegmentsModel,
  customer_leadfamly_kraeftens_bekaempelse: IntegrationKraeftensBekaempelseModel,
  customer_leadfamly_lidl_products: IntegrationLidlProductsModel,
  customer_leadfamly_philip_morris: IntegrationPhilipMorrisModel,
  customer_leadfamly_danskespil: IntegrationDanskeSpilModel,
  jwt: IntegrationJwtModel,
  openid_connect: IntegrationOpenIdConnectModel,
  ajax: IntegrationOpenIdConnectModel,
  scandlines: IntegrationScandlinesModel,
  customer_lobyco: IntegrationLobycoModel,
  customer_coop_app: IntegrationCoopModel,
  customer_leadfamly_grundfos: IntegrationGrundfosModel,
  clerk: IntegrationClerkModel,
  bulk_prize_vouchers: IntegrationBulkPrizeVouchersModel,
  customer_leadfamly_rituals: IntegrationRitualsModel,
  customer_leadfamly_userneeds: IntegrationUserneedsModel,
  pixel_tracking: IntegrationPixelTrackingModel,
  customer_kd: IntegrationKristeligDagbladModel,
  sports_alliance: IntegrationSportsAllianceModel,
  nfc: IntegrationNfcModel,
  customer_leadfamly_gf_advanced_map: IntegrationGfAdvancedMapModel,
  raptorsmartadvisor: IntegrationRaptorSmartAdvisorModel,
  ga: IntegrationGaModel,
  'esp/clickdimension': IntegrationEspClickdimensionModel,
  particle_generator: IntegrationParticleGeneratorModel,
  'esp/facebook_conversion': IntegrationEspFacebookConversionModel,
  customer_leadfamly_politikken_bezzerwisser: IntegrationBezzerwisserModel,
  'esp/customer_leadfamly_klasselotteriet': IntegrationKlasselotterietModel,
  sms_to_screen: IntegrationSmsToScreenModel,
  cookie_consent: IntegrationCookieConsentModel
};
